export default [
  {
    path: 'documentos/:wizard',
    name: 'files-wizard',
    meta: { permiso: 'ED050', requiereLogin: true },
    component: () => import('@/febos/chile/dnt/vistas/Wizard')
  },
  {
    path: 'documentos/:wizard/:id',
    name: 'files-wizard-update',
    meta: { permiso: 'ED050', requiereLogin: true },
    component: () => import('@/febos/chile/dnt/vistas/Wizard')
  },
  {
    path: 'expedientes-dashboard/:view',
    name: 'expedientes-dashboard',
    meta: { permiso: 'ED148', requiereLogin: true },
    component: () => import('@/febos/chile/dnt/vistas/Dashboard')
  },
  {
    path: 'expedientes/:id/actividades',
    name: 'file-activities',
    meta: { permiso: 'ED058', requiereLogin: true },
    component: () => import('@/febos/global/kanban/DntActivityBoard')
  },
  {
    path: 'documentos-personalizados/borradores',
    name: 'custom-documents-drafts',
    meta: { permiso: 'DOC01', requiereLogin: true },
    component: () => import('@/febos/global/customDocuments/vistas/CustomDrafts')
  },
  {
    path: 'expedientes/:view',
    name: 'files',
    meta: { permiso: 'ED066', requiereLogin: true },
    component: () => import('@/febos/chile/dnt/vistas/Files')
  },
  {
    path: 'open-text/buscar',
    name: 'opent-text',
    meta: { permiso: 'ED133', requiereLogin: true },
    component: () => import('@/febos/chile/dnt/vistas/OpenText')
  },
  {
    path: 'expediente/:view/:id/:idSubject',
    name: 'shared-file',
    meta: { requiereLogin: false },
    component: () => import('@/febos/chile/dnt/vistas/SharedFiles')
  },
  {
    path: 'doc-digital/entidades',
    name: 'dd-entidades',
    meta: { permiso: 'FEB99', requiereLogin: true },
    component: () => import('@/febos/chile/docDigital/MyEntities')
  },
  {
    path: 'doc-digital/tipos-documentos',
    name: 'dd-tipos-documentos',
    meta: { permiso: 'FEB99', requiereLogin: true },
    component: () => import('@/febos/chile/docDigital/MyDocuments')
  },
  {
    path: 'doc-digital/:view',
    name: 'dd-files',
    meta: { permiso: 'ED100', requiereLogin: true },
    component: () => import('@/febos/chile/docDigital/Files')
  },
  {
    path: 'input-doc-form/:from?',
    name: 'conventionInputForm',
    meta: { permiso: 'ED126', requiereLogin: true },
    component: () => import('@/febos/chile/dnt/components/wizard/companies/60100003-2/views/ConventionInputForm')
  },
  {
    path: 'input-metadata-form',
    name: 'conventionMetadataForm',
    meta: { permiso: 'ED128', requiereLogin: true },
    component: () => import('@/febos/chile/dnt/components/wizard/companies/60100003-2/views/ConventionMetadataForm')
  },
  {
    path: 'oficina-de-partes/:wizard',
    query: { from: 'entryExternalFile' },
    name: 'file-entry-external',
    meta: { layout: 'full-page', permiso: '*', requiereLogin: false }, // TODO: set permission
    component: () => import('@/febos/chile/dnt/vistas/ExternalUserWizard')
  }
];
